<template>

  <body>
    <div v-if="!editingCard" class="modalContainer active loginModal formsModal">
      <div class="actualModal">
        <a href="/#/user/profiles" class="closeModal"><i class="fal fa-times"></i></a>
        <div class="modalBodyOfItem" style="flex-direction: column; height: auto;">

          <form @submit.prevent="saveProfile" class="itemBodyLeftModal">

            <h4>Edit Profile</h4>
            <div class="dualInputContainerForm">
              <div class="inputsContainer">
                <h2>Profile Details</h2>
                <div class="individualInput">
                  <h5>Profile Name</h5>
                  <input v-model="profileForm.profileName" type="text" name="" id="" placeholder="Main Profile" />
                </div>
                <div class="individualInput">
                  <h5>Full Name</h5>
                  <input v-model="fullName" type="text" name="" id="" placeholder="John Doe" />
                </div>
                <div class="individualInput">
                  <h5>Phone Number</h5>
                  <input v-model="profileForm.phone" type="number" name="" id="" placeholder="8185555555" />
                </div>
                <div class="individualInput">
                  <h5>Email</h5>
                  <input v-model="profileForm.email" type="email" name="" id="" placeholder="you@example.com" />
                </div>
              <div class="individualInput">
                <h5>Country</h5>
                <select style="color: black" v-model="profileForm.shipping.country" name="state">
                  <option v-for="(country,key) in countries" :value="key">{{country}}</option>
                </select>
              </div>
              </div>
              <div class="inputsContainer">
                <h2>Payment/Billing</h2>
                <div class="individualInput">
                  <h5>Address</h5>
                  <input v-model="profileForm.shipping.address1" type="text" name="" id=""
                    placeholder="123 Cherry Ave" />
                </div>
                <div class="individualInput">
                  <h5>City</h5>
                  <input maxlength="20" v-model="profileForm.shipping.city" type="text" placeholder="New York" />
                </div>
                <div v-if="profileForm.shipping.country == 'US'" class="individualInput">
                  <h5>State</h5>
                  <select v-model="profileForm.shipping.state">
                    <option v-bind:key="key" v-for="(state,key) in states" :value="key">{{state}}</option>
                  </select>
                </div>
              <div v-if="profileForm.shipping.country != 'US'" class="individualInput">
                <h5>State</h5>
                <input v-model="profileForm.shipping.state" placeholder="State">
              </div>
                <div class="individualInput">
                  <h5>Zip Code</h5>
                  <input maxlength="10" v-model="profileForm.shipping.zip" type="text" name="" id=""
                    placeholder="10001" />
                </div>
                <div class="individualInput">
                  <h5>Credit Card</h5>
                  <div class="ccSaved">
                    <h6>{{cardType || 'Visa' }}</h6>
                    <!-- <p>4432 2293 8834 7743</p> -->
                    <p>**** **** **** {{last4}}</p>
                    <a @click="changeCard" class="changeCard">Change</a>
                  </div>
                </div>
              </div>
            </div>
            <div class="quickCheckout" style="padding-bottom: 50px;">
              <button type="submit">Save</button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!-- card modal -->

    <div v-if="editingCard" class="modalContainer active loginModal formsModal">
      <div class="actualModal">
        <a @click="changeCard" href="#" class="goBackModal"><i class="far fa-chevron-left"></i> Back</a>
        <div class="modalBodyOfItem">
          <div class="itemBodyLeftModal">
            <h4>Edit Card</h4>
            <div class="inputsContainer">
              <div class="individualInput">
                <h5>Name on Card</h5>
                <input v-model="profileForm.card.name" type="text" name="" id="" placeholder="John Doe" />
              </div>
              <div class="individualInput">
                <h5>Card Number</h5>
                <input maxlength="16" v-model="profileForm.card.number" type="text" name="" id="" placeholder="Enter Card Number" />
              </div>
              <div class="dualInputContainer">
                <div class="individualInput">
                  <h5>Exp Date</h5>
                  <input maxlength="5" v-model="expdate" type="text" name="" id="" placeholder="01/21" />
                </div>
                <div class="individualInput">
                  <h5>CVV</h5>
                  <input maxlength="4" v-model="profileForm.card.code" type="text" name="" id="" placeholder="912" />
                </div>
              </div>
            </div>
            <div class="quickCheckout dualBtnCheckout">
              <a @click="changeCard" href="#">Save Edits</a>
              <!-- <a href="#" class="oddBtn removeCard">Remove Card</a> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- ./ card modal -->
  </body>
</template>
<script>
  import {
    profileService
  } from '@/services/profiles'
  import {
    aesToAco,
    acoToAES,
    validateObject
  } from '@/helpers/acoData'
  import states from '@/helpers/states'
  import countries from '@/helpers/countries'
  import creditCardType from 'credit-card-type'
  export default {
    computed: {
      cardType() {
        if (!this.profileForm || !this.profileForm.card) return
        let {
          number
        } = this.profileForm.card
        if (!number) return this.profileForm.card.cardType
        let numString = number.toString()
        let cards = creditCardType(numString)
        if (cards && cards[0].type) return cards[0].type
        return cards
      },
      last4() {
        let {
          number
        } = this.profileForm.card
        if (!number) return
        // console.log(number,this.profileForm.card)
        return number.toString().slice(-4)
        // return this.profileForm.card.number.slice(-4)
      },
      profileId() {
        return this.$route.params.id
      },
      fullFromPart() {
        let {
          firstName,
          lastName
        } = this.profileForm
        return firstName + ' ' + lastName
      },
      partFromWhole() {
        let {
          fullName
        } = this
        let f = fullName.split(' ')[0]
        let l = fullName.split(' ')[1]
        return {
          firstName: f,
          lastName: l
        }
      }
    },
    methods: {
      changeCard() {
        console.log('changeCard called')
        this.editingCard = !this.editingCard
      },
      getProfile() {
        profileService.getProfiles()
          .then((eprofiles) => {
            let profiles = eprofiles.map(e => aesToAco(e))
            this.profiles = profiles
            let ourProfile = this.profiles.find(p => p.profileId == this.profileId)
            if (!ourProfile) return console.error('fck no profile')
            this.profileForm = ourProfile
            this.fullName = this.profileForm.shipping.firstName + ' ' + this.profileForm.shipping.lastName
            this.expdate = ourProfile.card.month + '/' + ourProfile.card.year
          })
        // this.$store.dispatch('profiles/getProfiles')

      },
      saveProfile() {
        if (this.expdate) {
          if (!this.expdate) return
          let split = this.expdate.split('/')
          let month = split[0]
          let year = split[1]
          if (month) this.profileForm.card.month = month
          if (year) this.profileForm.card.year = year
          if (this.cardType) this.profileForm.card.cardType = this.cardType
        }
        let firstName = this.fullName.split(' ')[0]
        let lastName = this.fullName.split(' ')[1]
        this.profileForm.shipping.firstName = firstName
        this.profileForm.shipping.lastName = lastName
        this.profileForm.billing = this.profileForm.shipping
        let {
          profileForm
        } = this
        console.log(`saving profile ${profileForm.profileId}`)
        console.log(profileForm)
        let valid = validateObject(profileForm)
        if (!valid) return console.log('invalid object')
        let encryptedProfile = acoToAES(profileForm)
        profileService.editProfile(encryptedProfile)
          .then((resp) => {
            console.log(`save profile resp ->`, resp)
            this.$store.dispatch('profiles/getProfiles')
            this.$router.push('/user/profiles')
            // if(!resp.success) return con
          })
      }
    },
    created() {
      this.getProfile()
    },
    data() {
      return {
        countries,
        expdate: null,
        editingCard: false,
        states,
        profiles: [],
        fullName: null,
        profileForm: {
          email: null,
          phone: null,
          profileName: null,
          shipping: {
            address1: null,
            address2: null,
            firstName: null,
            lastName: null,
            city: null,
            zip: null,
            state: null,
            country: null,
          },
          card: {
            name: null,
            number: null,
            code: null,
            month: null,
            year: null,
            cardType: null
            // zip: null,
          }
        }

      }
    },
    watch: {
    'profileForm.phone'(n,o) {
      // console.log(n,typeof n)
      let ns = n.toString()
      if(ns.length > 15) {
        this.profileForm.phone = ns.slice(0,15)
      }
    },
      '$route'(to, from) {
        // run created hook again

      }
    }
  }
</script>
